import { SelectedTasksStore } from '@bringg-frontend/monitoring';

import { routesMonitoringRootStore } from '../../routes-monitoring-screen/stores/routes-monitoring-root-store';
import { orderExplorerRootStore } from '../../order-explorer/stores/order-explorer-root-store';
import { View } from '../types';
import useMonitoringStore from './use-monitoring-store';

export const useSelectedStore = (): {
	store: SelectedTasksStore;
} => {
	const { view } = useMonitoringStore();

	return {
		store:
			view === View.tasks
				? orderExplorerRootStore.getStore().selectedTasksStore
				: routesMonitoringRootStore.getStore().selectedTasksStore
	};
};
